import React, { useState } from 'react';
import {
  IconButton,
  TableRow,
  TableCell,
  TableBody,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popper,
  Fade,
  Paper
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useLoading } from '../../../../hooks/useLoading';
import { useNotifications } from '../../../../hooks/useNotifications';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Form } from '../../../../components/Form';
import { useDataLayerValue } from '../../../../contextAPI/DataLayer';
import axios from 'axios';

export const ProjectTableBody = ({
  currHeaders,
  data,
  toggleUpdate,
  url,
  fields,
  options
}) => {
  const [openEdit, setOpenEdit] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [id, setId] = useState('');
  const { request } = useLoading();
  const { showNotifications } = useNotifications();
  const [{ _id, fname, lname, email }] = useDataLayerValue();

  const handleOpen = (event, currId) => {
    setAnchorEl(event.currentTarget);
    setId(currId);
    setOpenOptions((prevOpenOptions) => !prevOpenOptions);
  };

  const handleDelete = async () => {
    try {
      const res = await request(() =>
        axios.get(url + `/delete/${id}`, {
          headers: {
            employeeid: _id
          }
        })
      );
      if (res.data.statusCode !== 200) {
        showNotifications(
          'error',
          'Unable to delete item due to some error',
          5000
        );
      } else {
        showNotifications('success', 'Item successfully deleted', 5000);
        setOpenOptions(false);
        toggleUpdate();
      }
    } catch (error) {
      console.log('HERE');
      showNotifications(
        'error',
        'Unable to delete item due to some error',
        5000
      );
      console.log(error);
    }
  };

  const handleEditOpen = async () => {
    const res = await request(() =>
      axios.get(url + `/status/${id}`, {
        headers: {
          employeeid: _id
        }
      })
    );
    if (res.data.statusCode !== 200) {
      showNotifications('error', 'Unable to Edit Item', 5000);
    } else {
      console.log(res.data.body);
      console.log(fields);

      fields.map((field) => {
        if (field.type === 'dropdown' && field.name in res.data.body) {
          field['defaultValue'] = res.data.body[field.name];
        } else if (field.type === 'date' && field.name in res.data.body) {
          field.value = res.data.body[field.name].split('T')[0];
        } else {
          field.value = res.data.body[field.name];
        }
        return field;
      });

      setOpenEdit(true);
    }
  };

  const handleEditClose = () => {
    setOpenEdit(false);
    setOpenOptions(false);
    toggleUpdate();
  };

  return (
    <>
      <TableBody>
        {data.body.map((row) => {
          // console.log(row.isActive);
          return (
            <TableRow
              key={row._id}
              sx={{
                '&:last-child td, &:last-child th': {
                  border: 0
                }
              }}
            >
              {currHeaders.map((currHeader) => {
                return (
                  <TableCell key={currHeader.id} align="center">
                    {typeof row[currHeader.id] === 'boolean' ? (
                      row[currHeader.id] ? (
                        'Yes'
                      ) : (
                        'No'
                      )
                    ) : currHeader.id === 'projectName' ? (
                      <Link to={`${row['projectName']}`}>
                        {row['projectName']}
                      </Link>
                    ) : (
                      row[currHeader.id]
                    )}
                  </TableCell>
                );
              })}
              {row.isActive ? (
                <TableCell>
                  <IconButton onClick={(event) => handleOpen(event, row._id)}>
                    <MoreVertIcon />
                  </IconButton>
                  <Popper open={openOptions} anchorEl={anchorEl} transition>
                    {({ TransitionProps }) => (
                      <Fade {...TransitionProps} timeout={3500}>
                        <Paper>
                          <List>
                            {'editOption' in options && options.editOption ? (
                              <ListItem disablePadding>
                                <ListItemButton onClick={handleEditOpen}>
                                  <ListItemIcon>
                                    <EditIcon />
                                  </ListItemIcon>
                                  <ListItemText primary="Edit" />
                                </ListItemButton>
                              </ListItem>
                            ) : null}
                            {'deleteOption' in options &&
                            options.deleteOption ? (
                              <ListItem disablePadding>
                                <ListItemButton onClick={handleDelete}>
                                  <ListItemIcon>
                                    <DeleteIcon />
                                  </ListItemIcon>
                                  <ListItemText primary="Delete" />
                                </ListItemButton>
                              </ListItem>
                            ) : null}
                          </List>
                        </Paper>
                      </Fade>
                    )}
                  </Popper>
                </TableCell>
              ) : null}
            </TableRow>
          );
        })}
      </TableBody>
      <Form
        title="Edit Details"
        url={url + `/update/${id}`}
        open={openEdit}
        handleClose={handleEditClose}
        fields={fields}
        type="patch"
        headers={{
          employeeid: _id,
          empname: `${fname} ${lname}`,
          empemail: email
        }}
      />
    </>
  );
};
